import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';

import './_yup.extensions';

export default (t: TFunction): BaseSchema =>
  Yup.object().shape({
    email: Yup.string()
      .required(t('LABEL_ERROR_EMAIL_REQUIRED'))
      .email(t('LABEL_ERROR_INVALID_EMAIL'))
      .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC')),
    mailOption: Yup.boolean(),
    smsOption: Yup.boolean(),
    partOption: Yup.boolean(),
    turnstileToken: Yup.string().turnstileRequired(
      t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
    ),
  });
